import classNames from 'classnames'
import { IconFa, MenuButton, MenuButtonTagProps } from '../../atoms'
import styles from './RowMenuButton.module.css'

interface RowMenuButtonProps extends Omit<MenuButtonTagProps, 'children'> {
  containerClassName?: string
  isSelected?: boolean
  stickyRight?: boolean
  size?: 'sm' | 'md' | 'xs'
}
export const RowMenuButton = ({
  className,
  containerClassName,
  stickyRight,
  isSelected,
  size = 'sm',
  ...props
}: RowMenuButtonProps) => {
  return (
    <div
      className={classNames(
        styles.container,
        styles['size-' + size],
        containerClassName,
        stickyRight && styles.stickyRight
      )}
    >
      <MenuButton
        className={classNames(
          className,
          isSelected ? 'selected-aa-supported' : 'hover-aa-supported',
          styles.button,
          isSelected && styles.isSelected
        )}
        {...props}
      >
        <IconFa icon={['fas', 'ellipsis-v']} />
      </MenuButton>
    </div>
  )
}
